import { useMsal } from "@azure/msal-react";
import {
    CommandBar,
    FocusTrapZone,
    IButtonProps,
    ICommandBarItemProps,
    TextField,
    Toggle,
    useTheme
} from "@fluentui/react";
import { RootState } from "app/store";
import saveAs from "file-saver";
import { useAuthentication } from "global/Authentication";
import { AppDataSource } from "global/DataSources/AppDataSource";
import { MsalTokenSource } from "global/DataSources/MsalTokenSource";
import { IComponentContextMenu } from "model/Application";
import { bcbs_groupconfigurationsnapshot } from "model/AttributeOptionSets.type";
import React from "react";
import { connect, ConnectedProps, useDispatch } from 'react-redux';
import { useHistory, useParams } from "react-router";
import { RouterParams } from "../../../App";
import { emitCustomEvent, EViewType } from "../../../global/Application";
import {
    approveUnderwritingAction,
    ESaveType,
    SaveAsync, saveMergeAction
} from '../../../global/Application/dataActions';
import { addEditCommentToSnap, changeMergeSnap } from "../../../global/Reducer/compSlice";
import {
    setConcurrencyConfirmationModal, setProcessing, setViewType, toggleDisplayAll,
    toggleExpandAll,
    toggleShowTabs,
    toggleUnderwriterRequiredOnly
} from "../../../global/Reducer/statusSlice";
import { IComment } from "../../../model/FlexibleAttributeModel";
import CommentPanel from "../../../views/BlueRelationship/CommentPanel";
import { ConfirmationDialog } from "../../controls/ConfirmationDialog";

const overflowProps: IButtonProps = { ariaLabel: 'More commands' };

const headerToggleStyles: any = {
    root: {
        height: '44px',
        marginLeft: '10px',
        marginRight: '10px',
    }
}

interface IProps extends TComponentConnectedProps, IComponentContextMenu {
}


const ComparisonNavbar = (props: IProps) => {
    const history = useHistory();
    const { id, snapshotId, snapshot2 }: RouterParams = useParams();
    const [enableFocusTrap, setEnableFocusTrap] = React.useState(false);
    const authentication = useAuthentication();
    const [commentsPanel, setCommentsPanel] = React.useState(false);
    const [confirmationDialog, setConfirmDialog] = React.useState(<></>);
    const dispatch = useDispatch();

    const { instance } = useMsal();
    const tokenSource = new MsalTokenSource(instance);
    const dataSource = new AppDataSource(tokenSource);

    const preApproveUnderwriting = () => {
        setConfirmDialog(
            <ConfirmationDialog
                onClose={() => { setConfirmDialog(<></>) }}
                onContinue={() => { dispatch(approveUnderwritingAction(dataSource, history, true)); setConfirmDialog(<></>) }}
                continueText="Continue"
                cancelText="Cancel"
            >
                <p>Are you sure you are ready to move the right snapshot to Underwriting Review Complete?</p>
            </ConfirmationDialog>);

    }

    const rejectSnapUnderwriting = () => {
        setConfirmDialog(
            <ConfirmationDialog
                onClose={() => { setConfirmDialog(<></>) }}
                onContinue={() => {
                    dispatch(approveUnderwritingAction(dataSource, history, false));
                    setConfirmDialog(<></>)
                }}
                continueText="Continue"
                cancelText="Cancel"
            >
                <p>Are you sure you are ready to return for corrections? Add any final comments here:</p>
                <TextField
                    defaultValue=""
                    multiline
                    autoAdjustHeight
                    onChange={(event, newValue) => {
                        const commentObj: IComment = {
                            location: { snapshotId: snapshot2, id: id },
                            comment: newValue || "",
                            id: snapshot2!, status: 1
                        };
                        dispatch(addEditCommentToSnap(commentObj))
                    }}
                />
            </ConfirmationDialog>);
    }

    let _overflowItems: ICommandBarItemProps[] = [];

    let _items: ICommandBarItemProps[] = [];

    if (props.state.router.location.pathname.indexOf('comparison') > 0 || props.state.router.location.pathname.indexOf('underwritingReview') > 0 || props.state.router.location.pathname.indexOf('merge') > 0) {

        _items = [
            {
                key: 'showTabs',
                text: props.state.status.showTabs ? 'Show Inline' : 'Show Tabs',
                onClick: () => {
                    dispatch(toggleShowTabs());
                }
            },
            {
                key: 'expandAll',
                text: props.state.status.expandAllPanels ? 'Collapse All' : 'Expand All',
                onClick: () => {
                    dispatch(toggleExpandAll());
                }
            }, {
                key: 'displayChange',
                onRender: () => {
                    return (
                        <Toggle
                            label="Show Only Changes?"
                            inlineLabel
                            styles={headerToggleStyles}
                            checked={!props.state.status.displayAll}
                            onChange={() => dispatch(toggleDisplayAll())}
                        />);
                },
            }];

        _items.push({
            key: 'displayUnderwritingChange',
            onRender: () => {
                return (
                    <Toggle
                        label="Show Only UW/Audit Required Fields?"
                        inlineLabel
                        styles={headerToggleStyles}
                        checked={props.state.status.underwriterRequiredOnly}
                        onChange={() => dispatch(toggleUnderwriterRequiredOnly())}
                    />);
            },
        });

        const hideReconciliationUnless = ["Retired", "Underwriting Review Complete", "Gold Standard"]
        //@ts-ignore
        if (props.state.router.location.pathname.indexOf('merge') > 0 && props?.state?.comp?.leftSnap?.snapshot?.statuscode && hideReconciliationUnless.indexOf(bcbs_groupconfigurationsnapshot.statuscode[props.state!.comp!.leftSnap!.snapshot!.statuscode!]?.name) > -1 && props.state?.comp?.rightSnap?.snapshot?.statuscode && hideReconciliationUnless.indexOf(bcbs_groupconfigurationsnapshot.statuscode[props.state!.comp!.rightSnap!.snapshot!.statuscode!]?.name) > -1) {
            _items.push({
                key: 'Reconciliation',
                onRender: () => {
                    return (
                        <Toggle
                            label="Reconciliation"
                            inlineLabel
                            styles={headerToggleStyles}
                            checked={props?.state?.comp?.mergeSnap?.json?.reconciliation?.value ?? false}
                            onChange={(event, checked) => {
                                debugger;
                                dispatch(
                                    changeMergeSnap({
                                        json: {
                                            ...props.state.comp.mergeSnap.json,
                                            reconciliation: {
                                                type: 'bool',
                                                value: checked ?? false
                                            }
                                        }
                                    })
                                );
                            }}
                        />);
                },
            });

        }

        if (props?.state?.comp?.leftSnap?.snapshot && props?.state?.comp?.rightSnap?.snapshot)
            _items.push({
                key: 'compareExtract',
                text: 'Compare Extract',
                iconProps: { iconName: 'Generate' },
                onClick: () => {
                    try {
                        const leftSnapshot = props?.state?.comp?.leftSnap?.snapshot;
                        const rightSnapshot = props?.state?.comp?.rightSnap?.snapshot;

                        if (leftSnapshot && rightSnapshot) {
                            dispatch(setProcessing(true));
                            const response = dataSource.getSnapshotCompareExtract(
                                {
                                    bcbs_groupconfigurationsnapshotid: leftSnapshot.bcbs_groupconfigurationsnapshotid!,
                                    blobVersion: null,
                                },
                                {
                                    bcbs_groupconfigurationsnapshotid: rightSnapshot.bcbs_groupconfigurationsnapshotid!,
                                    blobVersion: null,
                                },
                                false,
                                false,
                                false,
                                false,
                                null,
                                () => {
                                    // TODO implement a progress status
                                    console.log(Date.now())
                                },
                            );

                            response
                                .then(res => {
                                    saveAs(res.blob, res.fileName);
                                })
                                .catch((reason) => {
                                    // lets create a new one is payload is not providing one
                                    emitCustomEvent({
                                        eventType: 'globalException',
                                        details: reason
                                    });
                                })
                                .finally(() => {
                                    dispatch(setProcessing(false));
                                });
                        }
                    } catch (err: any) {
                        // lets create a new one is payload is not providing one
                        emitCustomEvent({
                            eventType: 'globalException',
                            details: err
                        });
                    } finally {

                    }
                }
            });


        if (authentication.authorizations?.canEdit && props.state.router.location.pathname.indexOf('merge') > 0) {
            _items.push({
                key: 'merge',
                text: 'Create New Comprehensive Change From Selection',
                cacheKey: 'myCacheKey',
                onClick: () => {

                    dispatch(saveMergeAction(dataSource));

                    // saveMerge(dispatch, dataSource, props.state).then((url) => {
                    //     window.location.href = url!;
                    //     //history.push(url!);
                    // });
                }
            })
        }

        if (authentication.authorizations?.canUnderwritingReviewComplete && props.state.router.location.pathname.indexOf('underwritingReview') > 0) {
            _items.push({
                key: 'approveToUnderWritingReviewComplete',
                text: 'Approve Right Snapshot to Underwriting Complete Status',
                onClick: () => {
                    preApproveUnderwriting();
                }
            });

            _items.push({
                key: 'reject',
                text: 'Return Right Snapshot for Corrections',
                onClick: () => {
                    rejectSnapUnderwriting();
                }
            })
        }

    }

    if ((authentication.authorizations?.canEdit && props.state.data.snapshot?.statuscode === bcbs_groupconfigurationsnapshot.statuscode['Corrections Pending(808900005)'].value) || props.state.router.location.pathname.indexOf('underwritingReview') > 0) {

        _items.push({
            key: 'comments',
            text: 'View Comments',
            cacheKey: 'myCacheKey',
            onClick: () => { setCommentsPanel(!commentsPanel) }
        });
    }

    const theme = useTheme();

    let myLastSaveDate: Date = new Date();
    let lastSaveDate: Date = new Date();

    if (props.state?.status?.lastSaved) {
        myLastSaveDate = new Date(props.state?.status?.lastSaved);
    } else if (props.state?.data?.snapshot?.modifiedon) {
        myLastSaveDate = new Date(props.state?.data?.snapshot?.modifiedon);
    }

    if (props.state.status.concurrencyConfirmationModal?.modifiedon) {
        lastSaveDate = new Date(props.state.status.concurrencyConfirmationModal?.modifiedon);
    }

    //   if(!state.router.location.pathname.indexOf('records')){_items=[];}
    return <div style={{ position: 'sticky', top: '0' }}>
        <FocusTrapZone disabled={!enableFocusTrap}>
            <CommandBar
                styles={{ root: { backgroundColor: theme.palette.white, position: 'sticky', top: '10px' } }}
                items={_items}
                overflowItems={_overflowItems}
                overflowButtonProps={overflowProps}
                ariaLabel="actions"
                primaryGroupAriaLabel=""
                farItemsGroupAriaLabel="More actions"
            />

            {
                (props.state.router.location.pathname.indexOf('underwritingReview') > 0 || props.state.data.snapshot?.statuscode === bcbs_groupconfigurationsnapshot.statuscode['Corrections Pending(808900005)'].value) &&
                <CommentPanel
                    isOpen={commentsPanel}
                    isHiddenOnDismiss={true}
                    dismissPanel={() => { setCommentsPanel(!commentsPanel) }}
                />
            }

            {confirmationDialog}

            {props.state.status.concurrencyConfirmationModal &&
                <ConfirmationDialog
                    dialogContentProps={{
                        title: "Concurrency Conflict"
                    }}
                    onClose={() => {
                        dispatch(setConcurrencyConfirmationModal(null));
                        dispatch(setViewType(EViewType.ViewOnly));
                    }}
                    onContinue={async () => {
                        // //todo Armen:  make new snapshot from current state data store, keep original parent snapshot

                        // // TODO WARN* there is a duplicate of this function, that must be refactored
                        // dispatch(setConcurrencyConfirmationModal(null));
                        // const saveResult = await SaveAsync(dispatch, dataSource, props.state, { saveType: ESaveType.EConcurrencyConflict, onSaveStatusScreen: true });
                        // history.push(`/records/blueRelationship/${id}/groupConfiguration/${saveResult.snapshot?.bcbs_groupconfigurationsnapshotid}`);

                        // //not sure about the behavior we want to have but save has dispatch to update status.snapshot with latest
                        // //but the function may complete prior to dispatch cycle
                    }}
                    cancelText="Cancel"
                >
                    <p>
                        This configuration has been updated by {props.state.status.concurrencyConfirmationModal?.fullname}. Please reload to see the latest changes to apply your modifications.
                    </p>
                </ConfirmationDialog>
            }

        </FocusTrapZone>
    </div>;
};

function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connect(mapStateToProps)(ComparisonNavbar)